export enum DIALOG_ACTIONS {
  OPEN_DIALOG = "OPEN_DIALOG",
  CLOSE_DIALOG = "CLOSE_DIALOG",
}

export const openDialog = (payload) => ({
  type: DIALOG_ACTIONS.OPEN_DIALOG,
  payload,
});

export const closeDialog = () => ({
  type: DIALOG_ACTIONS.CLOSE_DIALOG,
  payload: {},
});
